module.exports = __webpack_public_path__ + "static/media/sms-contacts-icon.c13b52d9.svg";